var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPptx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18 7h-2.5c-.827 0-1.5-.673-1.5-1.5V2H6v16h12V7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18 6l-3-3.293V5.5c0 .275.225.5.5.5H18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    fill: "#605E5C",
    d: "M18.707 5.293l-3.707-4A1 1 0 0014.293 1H6a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-.293-.707zM18 6h-2.5a.501.501 0 01-.5-.5V2.707L18 6zM6 17.8V2.2c0-.11.09-.2.2-.2H14v3.5A1.5 1.5 0 0015.5 7H18v10.8a.2.2 0 01-.2.2H6.2a.2.2 0 01-.2-.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C47",
    d: "M15.95 11H14l-1-1-1 1v2.489c.419.316.935.511 1.5.511a2.5 2.5 0 002.45-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F6B",
    d: "M13.5 9a2.48 2.48 0 00-1.5.509V11h2V9.05a2.51 2.51 0 00-.5-.05z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC7B5",
    d: "M15 10h2a2.567 2.567 0 00-2-2v2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C43E1C",
    d: "M2 16h8a1 1 0 001-1V7a1 1 0 00-1-1H2a1 1 0 00-1 1v8a1 1 0 001 1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    d: "M6.08 8c.62 0 1.096.16 1.425.481.33.321.495.786.495 1.393 0 .39-.081.738-.245 1.042-.164.305-.395.541-.696.71a2.1 2.1 0 01-1.044.253H5V14h-.988V8H6.08zM5 11h.899C6.406 11 7 10.898 7 10c0-1.008-.641-1.012-1.069-1.012H5V11z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptx);
export default __webpack_public_path__ + "static/media/pptx.a8db24a1a4f03b4c860abab5b401d1f9.svg";
export { ForwardRef as ReactComponent };